export default __webpack_public_path__ + "static/media/01-460x460.d5d731b6.jpeg";